import { Box } from '@mui/material';
import { Modal } from 'components/Modal';
import { PrimaryButton } from 'components/lib/PrimaryButton';
import { TertiaryButton } from 'components/lib/TertiaryButton';
import type { FC } from 'react';
import { FooterWrapperStyle } from './DeleteConfirmationModal.styles';
import type { DeleteConfirmationModalProps } from './DeleteConfirmationModal.types';

const DeleteConfirmationModal: FC<DeleteConfirmationModalProps> = ({
  deletingElementTitle,
  deletingElementCategory,
  handleDelete,
  open,
  ...rest
}) => (
  <Modal
    {...rest}
    open={open}
    modalContent={`Are you sure you want to delete “${deletingElementTitle}”?`}
    title={`Delete ${deletingElementCategory}`}
    modalFooter={
      <Box sx={FooterWrapperStyle}>
        <PrimaryButton onClick={handleDelete} text={`Delete ${deletingElementCategory}`} />
        <TertiaryButton onClick={rest.onCloseIconClick} text="Cancel" />
      </Box>
    }
  />
);
export default DeleteConfirmationModal;
